import { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import {
  Divider,
  Link,
  Grid,
  Box,
  Typography,
  Button,
} from "@mui/material";
import TablePersonalDataAgree from "./TablePersonalDataAgree";
import SearchSelectPerson from "./SearchPerson";
import DateStatusRange from "./DropdownDatePerson";
import SignPdf from "./SignPdf";
import IndexSignPDF from "../SignPDF/IndexSignPDF";
import { useHistory } from "react-router-dom";
import { APIEndpointWeb, GetLocalStorageAccessToken, GetLocalStorageOrganization, webapi } from "../../../../client/web";
import Swal from "sweetalert2";
import LoadingIndicator from "./Loading/LoadingIndicator";

interface tableData {
  document_no: string,
  type: string,
  create_at: string,
  status: string
  priority: string
  status_edit:boolean;
}

export default function MainDocumentPersonal() {
  const [selectedTab, setSelectedTab] = useState("ทั้งหมด");
  const [documentList, setDocumentList] = useState<tableData[]>([]);
  const [searchString, setSearchString] = useState<string>("");
  const [searchInput, setSearchInput] = useState("");
  const [accessToken, setAccessToken] = useState<string>(GetLocalStorageAccessToken());
    const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();


  

  const countDocuments = (status: string) => {
    if (status === "ทั้งหมด") return documentList.length;
  
    if (status === "เสร็จสิ้น") {
      return documentList.filter((row) => row.status === "เสร็จสิ้น").length;
    }
    if (status === "รอดำเนินการ") {
      return documentList.filter((row) => row.status === "รอดำเนินการ").length;
    }
    if (status === "ยกเลิก") {
      return documentList.filter((row) => row.status === "ยกเลิก").length;
    }
    return 0;
  };


  const DocumentPreview = async() => {
        let glso = GetLocalStorageOrganization();
        try {
          setLoading(true)
            const dataFormApi = {
                    hcode: glso ? glso.hcode : "",
                    document_no: ""
                }
            let { data } = await webapi.post(`${APIEndpointWeb.PostDetailDocumentPreview}`, dataFormApi,
                { headers: { Authorization: `Bearer ${accessToken}` }});
                
            history.push({pathname: "/form-personal-new"});
        } catch (error: any) {
          setLoading(false)
          try {
                if (error.response.data.message === "have document in this hcode") {
                      Swal.fire({
                            icon: "error",
                            title: "ไม่สามารถขอเอกสารได้",
                            text: "เนื่องจากมีเอกสารที่รอดำเนินการอยู่หรือเสร็จสิ้นแล้ว",
                            confirmButtonText: "ตกลง",
                });
                } else if (error.response.data.message === "this account does not have permission") {
                    Swal.fire({
                            icon: "error",
                            title: "ไม่สามารถขอเอกสารได้",
                            text: "เนื่องจากคุณไม่ได้รับสิทธิ์ในการขอเอกสารนี้",
                            confirmButtonText: "ตกลง",
                });
                } else {
                          Swal.fire({
                            icon: "error",
                            title: error.response.data.message,
                            // text: "คุณไม่ได้รับสิทธิ์ในการขอเอกสารนี้",
                            confirmButtonText: "ตกลง",
                });
              }
            } catch (error) {
                Swal.fire({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: "กรุณาติดต่อเจ้าหน้าที่",
                        confirmButtonText: "ตกลง",
                      });
            }
        } finally {
          setLoading(false)
        }
  };
  

  return (
    <Box sx={{ height: "100%" }}>
      <LoadingIndicator open={loading} />
      <Grid
        item
        xs={12}
        lg={12}
        sx={{
          p: 4,
          background: "#ffffff",
          borderRadius: "10px",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        {/* Header with Divider */}
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ color: "#474747" }}>
              เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล (DSA)
            </Typography>
          </Grid>

          <Grid item xs>
            <Divider sx={{ backgroundColor: "#EEEEEE" }} />
          </Grid>

          <Grid item>
            {/* <Link href="/form-personal-new" underline="none"> */}
              <Button
                onClick={() => DocumentPreview()}
                variant="outlined"
                sx={{
                  borderRadius: 20,
                  borderColor: "#2F4491",
                  color: "#2F4491",
                  fontFamily: "Sarabun, sans-serif",
                  whiteSpace: "nowrap",
                }}
                startIcon={<AddIcon />}
              >
                ขอเอกสารข้อตกลงแบ่งปันข้อมูล
              </Button>
            {/* </Link> */}
          </Grid>
        </Grid>
        {/* Tabs Section */}
        <Box sx={{ display: "flex", my: 2, flexWrap: "wrap" }}>
          {["ทั้งหมด", "เสร็จสิ้น", "รอดำเนินการ", "ยกเลิก"].map((tab) => (
            <Button
              key={tab}
              onClick={() => {
                setSelectedTab(tab)
                // setSearchInput("")
                // setSearchString("")
             
              }}
              sx={{
                mr: 1,
                px: 3,
                py: 1,
                borderRadius: "20px",
                height: "26px",
                backgroundColor: selectedTab === tab ? "#2F6E89" : "#EDEDED6E",
                color: selectedTab === tab ? "#fff" : "#2F4491",
                "&:hover": {
                  backgroundColor: selectedTab === tab ? "#2F6E89" : "#EDEDED",
                },
              }}
            >
              {tab} ({countDocuments(tab)}) 
            </Button>
          ))}
        </Box>
        {/* Search Section */}
        <Grid item>
          <SearchSelectPerson setSearchInput={setSearchInput} searchInput={searchInput} setSearchString={setSearchString} />
        </Grid>
        <Grid item sx={{mt:2}}>
          <Divider sx={{ backgroundColor: "#EEEEEE" }} />
        </Grid>
        <Grid>
          {/* Date Range Section */}
          {/* Dropdown for Document Type */}
          {/* Dropdown for Status */}
          <DateStatusRange />
        </Grid>
        <Grid item xs={12}>
          {/* <SignPdf/> */}
          {/* <IndexSignPDF/> */}
          <TablePersonalDataAgree searchString={searchString} selectedTab={selectedTab} setDocumentList={setDocumentList}/>
        </Grid>
      </Grid>
    </Box>
  );
}